<template>
    <div>
        <div v-if="!creating && !editing">
            <h4>Liste des commissaires aux comptes</h4>
            <b-alert :show="noAuditor" variant="secondary">
                Aucun·e commissaire aux comptes n'a été saisi·e pour cette
                société
            </b-alert>

            <div>
                <auditor
                    v-for="auditor in auditors"
                    :key="'auditor' + auditor.id"
                    :item="auditor"
                    :can-edit="true"
                    @auditor-is-deleted="update"
                />
            </div>

            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('physical')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne physique
            </b-button>
            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('moral')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne morale
            </b-button>
        </div>

        <div v-if="personType === 'moral' && linkType==='auditors'">
            <moral-person-search v-if="searching"/>
            <moral-person-create v-if="creating"/>
            <moral-person-edit v-if="editing"/>
        </div>

        <div v-if="personType === 'physical' && linkType==='auditors'">
            <physical-person-search v-if="searching"/>
            <physical-person-create v-if="creating" :person-type="'auditors'"/>
            <physical-person-edit v-if="editing"/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Auditor from './Auditor'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import PappersAuditor from './PappersAuditor'
import loading from '../../../../common/components/loading'

export default {
    name: 'Auditors',

    components: {
        PappersAuditor,
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Auditor,
    },

    props: {
        clientData: {},
        fullVue: null,
        embedded: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
            linkType: (state) => state.legalVM.linkType,
        }),

        auditors() {
            return this.client?.auditors?.data ?? []
        },

        noAuditor() {
            return (
                this.auditors.length === 0 && !this.searching && !this.editing
            )
        },

        pappersAuditors() {
            return this.client?.pappers_data?.auditors ?? []
        },

        noPappersAuditor() {
            return (
                this.pappersAuditors.length === 0 &&
                !this.searching &&
                !this.editing
            )
        },
    },

    created() {
        if (!this.embedded) {
            this.$store.commit('legalVM/SET_CLIENT', this.clientData)
            this.$store.commit('legalVM/RESET_STATUS')
        }
    },

    methods: {
        update() {
            if (this.fullVue) {
                this.$emit('update-company')
            } else {
                location.reload()
            }
        },

        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'auditors')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'auditors')
            this.$store.commit('legalVM/SHOW_EDIT')
        },

        resetKey() {
            this.key = Date.now()
        },

        async updatePappers() {
            console.log('pappers update')
            this.loading = true
            this.pappers = {}
            try {
                await axios.put(
                    `/moralPersons/${this.client.main_moral_person_id}/pappers`
                )
                await this.$store.dispatch(
                    'legalVM/getClientData',
                    this.client.id
                )
                this.loading = false
                this.resetKey()
            } catch (error) {
                console.error(error)
            }
        },
    },
}
</script>

<style scoped></style>
